// GENERATED FILE — do not edit by hand.
// Source: deploy_output_2026-05-13T00-27-27.json
// Run `node scripts/sync_addresses.mjs` from metha-docs/ to regenerate.

export interface SepoliaDeployManifest {
  network: string;
  chainId: number;
  deployer: string;
  deployedAt: string;
  addresses: {
    EternalStorage: `0x${string}`;
    MethaToken: `0x${string}`;
    OpenGovernance: `0x${string}`;
    MethaCrowdsale: `0x${string}`;
    AuditingPool: `0x${string}`;
    AuditorRegistryV2: `0x${string}`;
  };
  config: {
    tokenName: string;
    tokenSymbol: string;
    periodDurationSec: number | null;
    tokensPerPeriod: number | null;
    ballotDurationSec: number | null;
    auditorRewardWeiMeth: string | null;
  };
}

export const SEPOLIA_MANIFEST: SepoliaDeployManifest = {
  network: "sepolia",
  chainId: 11155111,
  deployer: "0x57829c5f9A5A2b09C22715133F1250d5DC1860c9",
  deployedAt: "2026-05-13T00:27:27.500Z",
  addresses: {
    EternalStorage: "0xD81fFB850e44dd131D30E94eeD033CB9c8c546d9",
    MethaToken: "0x0A1e366572f63bCa45A66dE4F5F1Ab5A62b3E16c",
    OpenGovernance: "0x7BF8dd021477A44eD0F4b5eB48cB80cfb594917B",
    MethaCrowdsale: "0x7B96b7e7670C6330b5F4f8b3F46245e4F49FF560",
    AuditingPool: "0xD301Cff18Cec35F2c698a0fD7DFf81AF81098571",
    AuditorRegistryV2: "0xDead08DfFa69FF1bde30A72E4BD993A67c61Ee03",
  },
  config: {
    tokenName: "Metha Token",
    tokenSymbol: "METH",
    periodDurationSec: 180,
    tokensPerPeriod: 10000,
    ballotDurationSec: 180,
    auditorRewardWeiMeth: "500000000000000000",
  },
};

export const ADDRESSES = SEPOLIA_MANIFEST.addresses;
export type ContractName = keyof typeof ADDRESSES;
